import { getTemplateAttachments } from "@/pages/templates/repositories/TemplatesRepositorie";
import { useTemplatesContext } from "@/pages/templates/context/templatesContext";
import { get } from "lodash-es";

type Props = {
	setIsTemplateAttachmentsLoading: (isLoading: boolean) => void;
	setTemplateAttachmentsError: (err: string) => void;
	TemplateId: number | null;
};

export const useSearchTemplateAttachments = ({
	setIsTemplateAttachmentsLoading,
	setTemplateAttachmentsError,
	TemplateId,
}: Props) => {
	const {
		actions: { setTemplateAttachmentsList },
	} = useTemplatesContext();

	return async () => {
		setTemplateAttachmentsList([]);
		setIsTemplateAttachmentsLoading(true);
		const res = await getTemplateAttachments(TemplateId as number);
		if (res.ok) {
			const rowsSource = get(res, "data.tables[0].rows", []);
			setTemplateAttachmentsList(rowsSource);
			setIsTemplateAttachmentsLoading(false);
		} else {
			setIsTemplateAttachmentsLoading(false);
			setTemplateAttachmentsError(res.message);
		}
	};
};
